<dacks-header [appName]="displayTitle" [userContext]="userContext">
  <dacks-app-switch slot="app-switch"></dacks-app-switch>
  <datev-copilot slot="copilot" [attr.stage]="copilotStage"></datev-copilot>
  <!-- noch nicht, finales GO ist noch offen für die DATEV Mitteilungen
  <dacks-notifications slot="notifications"></dacks-notifications>
  -->
  <dacks-help-menu slot="help-menu" [feedback]="feedbackUrl"></dacks-help-menu>
  <dacks-user-menu slot="user-menu" [userName]="displayUser" [licenseCheck]="true"
                   (login-click)="login()" (logout-click)="logout()">
    <a routerLink="/terms-of-use" slot="terms-of-use"></a>
  </dacks-user-menu>
</dacks-header>
